import { LeasingType } from 'modules/types/LeasingOffer';
import { HeadlineTitle } from 'modules/ui';
import { useTranslation } from 'react-i18next';
import { Currency } from 'modules/ui/table/currencyContainer';
import {
  LeasingInstallmentContainer,
  StyledLabel,
  StyledSubtitle,
  StyledTitle,
} from './styled';

export interface LeasingInstallmentInfoCardProps {
  installmentAmount?: string;
  leasingType: LeasingType;
}

export const LeasingInstallmentInfoCard: React.FC<
  LeasingInstallmentInfoCardProps
> = ({ installmentAmount, leasingType }) => {
  const { t } = useTranslation();

  const cardTitle =
    leasingType === LeasingType.FINANCIAL
      ? t(
          'leasingCalculator.infoCalculation.leasingInstallmentInfo.financialInstallmentAmount',
        )
      : t(
          'leasingCalculator.infoCalculation.leasingInstallmentInfo.operationalInstallmentAmount',
        );

  return (
    <LeasingInstallmentContainer leasingType={leasingType}>
      <StyledLabel>
        {t(
          'leasingCalculator.infoCalculation.leasingInstallmentInfo.personalVehicles',
        )}
      </StyledLabel>
      <StyledTitle>{cardTitle}</StyledTitle>
      <HeadlineTitle>
        {installmentAmount} {Currency.EURO}
      </HeadlineTitle>
      <StyledSubtitle>{leasingType} </StyledSubtitle>
    </LeasingInstallmentContainer>
  );
};
